import { graphql } from '@/graphql-setup'

export const TACHOGRAPH_INFRINGEMENT_QUERY = graphql(`
  query TachographInfringement($id: ID!) {
    tachographInfringement(id: $id) {
      id
      createdAt
      periodStartDate
      periodEndDate
      infringementTimestamp
      vehicleRegistrationNumber
      details
      archivedAt
      closedAt
      archivedBasis
      wronglyGenerated
      wronglyGeneratedExplanation
      solution
      leadersComment
      user {
        id
        fullName
        phoneNumber
      }
      category {
        id
        identifier
        title
        description
        legalBasis
        euReference
        severity
      }
      attachments {
        id
        name
        file
      }
      actionLogs {
        id
        action
        attachmentName
        createdAt
        user {
          id
          fullName
        }
      }
    }
  }
`)

export const COMPANY_TACHOGRAPH_INFRINGEMENT_SETTINGS_QUERY = graphql(`
  query CompanyTachographInfringementSettings {
    companyTachographInfringementSettings {
      id
      generationEnabled
      countryStartEnabled
      countryStopEnabled
      manualEntryEnabled
      manualEntryVehicleChangeEnabled
      borderCrossingEnabled
      minManualEntryGapMinutes
      maxManualEntryGapMinutes
    }
    tachographInfringementCategories {
      id
      identifier
      title
      description
    }
  }
`)
